import React from "react";
import "./BrandsCarousel.css";

const brandLogos = [
  "/assets/brands/brand1.png",
  "/assets/brands/brand2.png",
  "/assets/brands/brand3.png",
  "/assets/brands/brand4.png",
  "/assets/brands/brand5.png",
  "/assets/brands/brand6.png",
  "/assets/brands/brand7.png",
  "/assets/brands/brand8.png",
  "/assets/brands/brand9.png",
  "/assets/brands/brand10.png",
  "/assets/brands/brand11.png",
];

const BrandsCarousel = () => {
  return (
    <div className="brands-title">
      <h2>Trusted By</h2>
      <div className="brands-carousel"> 
        <div className="carousel-track">
        <div className="logo-strip">
          {[...brandLogos, ...brandLogos].map((logo, index) => (
            <div className="logo-wrapper" key={index}>
              <img src={logo} alt={`Brand ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>

      </div>
      
    </div>
  );
};

export default BrandsCarousel;
